const getParentPost = (superPostId, responses, response) => {
  const postIds = response.order.split('.')
    .map((id) => Number(id))
    .filter((id) => id !== superPostId && id !== response.id);
  const parentPostId = postIds[postIds.length - 1];
  return parentPostId && responses.find(({ id }) => id === parentPostId);
};

const assignParentIds = (superPostId, responses) => {
  return responses.map((response) => {
    const parentPost = getParentPost(superPostId, responses, response);
    return {
      ...response,
      parentPostId: parentPost && parentPost.id,
      responses: [],
    };
  });
};

export const nestPostReplies = (superPostId, responses) => {
  const postList = assignParentIds(superPostId, responses);
  postList.forEach((response) => {
    if (response.parentPostId) {
      const parentPost = postList.find(({ id }) => id === response.parentPostId);
      if (parentPost) {
        parentPost.responses.push(response);
      }
    }
  });
  return postList.filter(({ parentPostId }) => !parentPostId);
};
